import React from 'react';
import TypedOrderForm from './TypedOrderForm';

/**
 * Create K.I.N.D. Order — a thin configuration over TypedOrderForm.
 *
 * Clients come from the database (Settings → Order clients → KIND); the 26 entries that used to
 * be hardcoded here were seeded 1:1 (same slugs) so existing KIND bookings keep matching.
 */
export const KIND_ORDER_CONFIG = {
  orderType: 'kind',
  title: 'Create K.I.N.D. Order',
  noun: 'KIND Order',
  buttonLabel: 'Create KIND Order',
  positions: [
    { value: 'Development', label: 'Development' },
    { value: 'AI Content Production', label: 'AI Content Production' },
    { value: 'Hair & Make-Up', label: 'Hair & Make-Up' },
    { value: 'Art Direktion', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'Foto Assist', label: 'Foto Assist' },
    { value: 'Video', label: 'Video' },
    { value: 'Digi-OP', label: 'Digi-OP' },
    { value: 'Styling', label: 'Styling' },
    { value: 'Styling Assist', label: 'Styling Assist' },
    { value: 'LOGISTIK / WARENAUFBEREITUNG', label: 'LOGISTIK / WARENAUFBEREITUNG' },
    { value: 'PRODUCER', label: 'PRODUCER' },
    { value: 'Art Buying', label: 'Art Buying' },
    { value: 'Account Management', label: 'Account Management' },
    { value: 'Videoproducing', label: 'Videoproducing' },
    { value: 'Post Production', label: 'Post Production' },
    { value: '3D Artist', label: '3D Artist' },
    { value: 'Marketing I Sales 70440', label: 'Marketing I Sales 70440' },
  ],
  defaultPosition: 'AI Content Production',
  fixedPosition: false,
  studio: 'Remote',
  locations: [
    { value: 'kind', label: 'K.I.N.D.', match: ['KIND'] },
    { value: 'cgi', label: 'CGI', match: [] },
  ],
  fixedLocation: false,
  set: 'digital Production',
  billing: ['daily', 'hourly', 'kpi'],
  infoLabel: 'KIND Info',
  infoPlaceholder: 'KIND-specific information (optional)',
  groupPrefix: 'kind',
};

function CreateKindOrder() {
  return <TypedOrderForm config={KIND_ORDER_CONFIG} />;
}

export default CreateKindOrder;
